import { Button, Row, Select, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import {
    EditOutlined,
    CloseSquareOutlined,
    CheckSquareOutlined,
    SearchOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons'

const AddUserLog = ({ editedTimeLogs, setEditedTimeLogs }) => {

    const [isAddUserVisible, setIsAddUserVisible] = useState(false)
    const [availableUsers, setAvailableUsers] = useState([])

    const pdfDataInRedux = useSelector((state) => state.reportTimesheet)
    const pdfData = pdfDataInRedux?.pdfData
    const projectData = pdfDataInRedux?.pdfSelectedData

    const handleSelectUser = (value) => {
        const selectedUser = projectData.assignees.find(
            (user) => user.value === value
        )
        if (!selectedUser) return

        const newUserObj = {
            _id: { assigneeId: selectedUser.value },
            addManual: true,
            list: [

            ],
        }

        setEditedTimeLogs((prev) => ({
            ...prev,
            tableBody: [...prev.tableBody, newUserObj],
        }))
        setIsAddUserVisible(false)
    }
    useEffect(() => {
        if (editedTimeLogs?.tableBody && projectData?.assignees) {
            const existingIds = editedTimeLogs.tableBody.map(
                (u) => u._id?.assigneeId
            )
            const filtered = projectData.assignees.filter(
                (user) => !existingIds.includes(user.value)
            )
            setAvailableUsers(filtered)
        }
    }, [editedTimeLogs?.tableBody, projectData?.assignees])

    return (
        <div>
            <Row style={{ padding: '0px', marginTop: 0, margin: "15px 20px" }}>
                {!isAddUserVisible ? (

                    availableUsers.length > 0 &&
                    <Row style={{ border: !isAddUserVisible ? "1px dashed #cfd7db" : "none", justifyContent: "center", borderRadius: "10px", width: "100%" }}>

                        <Tooltip title={"Add User"}>

                            <Button style={{ background: "transparent", border: "none", boxShadow: "none" }} onClick={() => setIsAddUserVisible(true)} icon={<PlusCircleOutlined style={{ color: "#00000096", fontSize: "23px" }} />} />
                        </Tooltip>
                    </Row>

                ) : (
                    <Select
                        showSearch
                        placeholder="Select user to add"
                        className='select_input_height'
                        style={{ width: "100%", height: "100%" }}
                        onChange={handleSelectUser}
                        onBlur={() => setIsAddUserVisible(false)} // close if clicked away
                        filterOption={(input, option) =>
                            option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                        options={availableUsers.map((user) => ({
                            value: user.value,
                            label: `${user.label} ${user?.designation?.name ? `(${user.designation.name})` : ''}`,
                        }))}
                    />
                )}
            </Row>
        </div>
    )
}

export default AddUserLog
